import { render, staticRenderFns } from "./transactions.vue?vue&type=template&id=2ccbcc00&scoped=true"
import script from "./transactions.vue?vue&type=script&lang=js"
export * from "./transactions.vue?vue&type=script&lang=js"
import style0 from "./transactions.vue?vue&type=style&index=0&id=2ccbcc00&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ccbcc00",
  null
  
)

export default component.exports